<template>
	<div class="modal fade" role="dialog" aria-labelledby="closeContactosOportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title d-flex" id="closeContactosOportunidadLabel" v-if="modal=='index'">
						<div class="bg-blue border-radius text-white text-center rounded-circle mb-0 mr-1" style="width: 35px; height: 35px;">
							<i class="material-icons" style="vertical-align: unset;">
								people
							</i>
						</div>
						Contactos
					</h3>
					<h5 class="modal-title" id="closeContactosOportunidadLabel" v-if="modal=='create'">
						Agregar Contacto
					</h5>
					<h5 class="modal-title" id="closeContactosOportunidadLabel" v-if="modal=='edit'">
						Editar Contacto
					</h5>
					<h5 class="modal-title" id="closeContactosOportunidadLabel" v-if="modal=='show'">
						{{form.nombre}}
					</h5>

					<div class="text-right">
						<button class="btn btn-link text-muted btn-sm" type="button" v-tooltip="'Buscar contacto'" v-if="false">
							<i class="material-icons">search</i>
						</button>
						<button class="btn btn-link text-muted btn-sm" v-on:click="getContactos" v-tooltip="'Actualizar contacto'" v-if="modal=='index'">
							<i class="material-icons">refresh</i>
						</button>
						<button class="btn btn-link text-muted btn-sm" v-on:click="create" v-tooltip="'Agregar contacto'" v-if="modal=='index' && !disabledDF">
							<i class="material-icons">add</i>
						</button>
						<button type="button" class="btn btn-link text-muted btn-sm" data-dismiss="modal" aria-label="Close" v-if="modal=='index'">
							<i class="material-icons">close</i>
						</button>
						<button type="button" class="close" v-if="modal=='create'" v-on:click="backIndex">
							<i class="material-icons">arrow_back</i>
						</button>
					</div>
				</div>
				<div class="modal-body pt-0">
					<preloader v-if="loading"></preloader>
					<div v-if="modal=='index'">
						<div class="table-responsive" v-if="contactos.length>0">
							<table v-bind:class="{'table table-borderless table-hover':true, 'table-sm':compacta}">
								<thead>
									<tr class="border-bottom">
										<th>Nombre</th>
										<th class="d-none d-sm-none d-md-none d-lg-table-cell">Correo</th>
										<th class="d-none d-sm-none d-md-none d-lg-table-cell">Número de Teléfono</th>
										<th class="d-none d-sm-none d-md-none d-lg-table-cell">Puesto</th>
										<th class="text-right" width="125px">
											<div class="custom-control custom-switch">
												<input type="checkbox" class="custom-control-input" id="compacta" v-model="compacta">
												<label class="custom-control-label" for="compacta">Compacta</label>
											</div>
										</th>
									</tr>
									<tr>
										<td colspan="5" class="p-1">
											<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
												Contactos ({{contactos.length}})
											</div>
										</td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(contacto, index) in contactos" v-on:click="show(contacto)" class="cursor-pointer">
										<td>
											<div class="d-flex">
												<div class="bg-info text-white mr-1 rounded-circle text-center" style="width: 25px; height: 25px;">
													{{getIni(contacto.NOMBRE_CONTACTO)}}
												</div>
												{{contacto.NOMBRE_CONTACTO}}
											</div>
										</td>
										<td class="text-center d-none d-sm-none d-md-none d-lg-table-cell">
											<a :href="'mailto:'+contacto.EMAIL" class="text-muted" v-if="contacto.EMAIL" v-on:click.stop="">
                                                {{contacto.EMAIL}}
                                            </a>
										</td>
										<td class="text-center d-none d-sm-none d-md-none d-lg-table-cell">
											<small v-if="contacto.CELULAR || contacto.TELEFONO">
                                                <a :href="'tel:'+contacto.CELULAR" v-tooltip="'Celular'" v-on:click.stop="">
                                                    {{ contacto.CELULAR }}
                                                </a>

                                                <span v-if="contacto.CELULAR && contacto.TELEFONO">
                                                	/
                                                </span>

                                                <a :href="'tel:'+contacto.TELEFONO" v-tooltip="'Teléfono'" v-on:click.stop="">
                                                    {{contacto.TELEFONO}}
                                                </a>
                                            </small>
										</td>
										<td class="d-none d-sm-none d-md-none d-lg-table-cell" v-text="contacto.PUESTO"></td>
										<td class="text-right" width="125px">
											<div class="table-hover-options" v-if="!disabledDF">
			                                    <a href="#" class="text-muted ml-2 p-1" v-tooltip="'Editar contacto'" v-on:click.prevent.stop="edit(contacto)">
			                                        <i class="material-icons">edit</i>
			                                    </a>
			                                    <a href="#" class="text-muted ml-2 p-1" v-tooltip="'Eliminar contacto'" v-on:click.prevent.stop="deleteContacto(contacto.CODIGO_CONTACTO)">
			                                        <i class="material-icons">delete</i>
			                                    </a>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<empty icon="event" title="Agregar Contactos" description="Para poder visualizar el listado de las Contactos debes agregar una nueva." v-if="contactos.length<=0 && !loading">
						</empty>
						<div v-if="false" class="m-3">
					    	<div class="row justify-content-center">
								<div class="col-12 col-sm-6 col-md-4 col-xl-3 mb-3" v-for="(contacto, index) in contactos">
			                        <div class="card mt-4">
			                            <div class="card-img-top text-center pt-1" style="margin-top: -1.5rem;">
			                                <div class="border bg-info text-white border-secondary rounded-circle m-auto" style="width: 62px; height: 62px; border: 5px solid #dee2e6 !important;">
			                                    <i class="material-icons large" style="font-size: 50px;">perm_contact_calendar</i>
			                                </div>
			                            </div>
			                            <div class="card-body py-1">
			                                <div>
			                                    <label>Código:</label> {{contacto.CODIGO_CONTACTO}} 
			                                </div>
			                                <h5 class="card-title text-truncate mb-1">
			                                    <a href="#">
			                                        <small>{{contacto.NOMBRE_CONTACTO}}</small>
			                                    </a>
			                                </h5>
			                                <div class="card-text mb-2">
			                                    <div class="media">
			                                        <div class="align-self-center mr-3">
			                                            Puesto:
			                                        </div>
			                                        <div class="media-body text-truncate">
			                                            <span class="badge badge-dark" v-if="contacto.PUESTO">
			                                            	{{contacto.PUESTO}}	
			                                            </span>
		                                                <small class="text-truncate" v-else>
		                                                   No definido 
		                                                </small>
			                                        </div>
			                                    </div>

			                                    <div class="media">
			                                        <div class="align-self-center mr-3">
			                                            <i class="material-icons" v-tooltip="'Correo Electrónico'">mail</i>
			                                        </div>
			                                        <div class="media-body text-truncate">
			                                            <a :href="'mailto:'+contacto.EMAIL" class="text-muted" v-if="contacto.EMAIL">
			                                                {{contacto.EMAIL}}
			                                            </a>
		                                                <small class="text-truncate" v-else>
		                                                   No definido 
		                                                </small>
			                                        </div>
			                                    </div>

			                                    <div class="media">
			                                        <div class="align-self-center mr-3">
			                                            <i class="material-icons" v-tooltip="'Teléfono'">phone</i>
			                                        </div>
			                                        <div class="media-body">
		                                                <small v-if="contacto.CELULAR && contacto.TELEFONO">
		                                                    <a :href="'tel:'+contacto.CELULAR" v-tooltip="'Celular'">
		                                                        {{ contacto.CELULAR }}
		                                                    </a>

		                                                    <span v-if="contacto.CELULAR && contacto.TELEFONO">
		                                                    	/
		                                                    </span>

		                                                    <a :href="'tel:'+contacto.TELEFONO" v-tooltip="'Teléfono'">
		                                                        {{contacto.TELEFONO}}
		                                                    </a>
		                                                </small>
		                                            
		                                                <small v-else>
		                                                    No definido
		                                                </small>
			                                        </div>
			                                    </div>
			                                </div>
			                            </div>
			                            <div class="card-footer">
			                                <div class="form-row">
			                                	<div class="col-6">
				                                    <a href="#" class="btn btn-primary btn-block text-center" v-tooltip="'Editar'" v-on:click.prevent="edit(contacto)">
				                                        <i class="material-icons">edit</i>
				                                        Editar
				                                    </a>
			                                	</div>
			                                	<div class="col-6">
				                                    <a href="#" class="btn btn-primary btn-block text-center" v-tooltip="'Eliminar'" v-on:click.prevent="deleteContacto(contacto.CODIGO_CONTACTO)">
				                                        <i class="material-icons">delete</i>
				                                        Eliminar
				                                    </a>
			                                	</div>
			                                </div>
			                            </div>
			                        </div>
			                    </div>
							</div>
						</div>
					</div>
					<div v-else class="row pt-3">
						<div class="col-md-8">
							<div class="form-row">
								<div class="col-md-8 mb-3" v-if="modal!='show'">
		                            <label for="name">Nombre:</label>
		                            <input id="name" type="text" class="form-control form-control-sm" name="name" placeholder="Nombre" maxlength="50" v-model="form.nombre">
		                            <div v-if="errors && errors.nombre" class="text-danger">
				                     	{{ errors.nombre[0] }}
				                  	</div>
		                        </div>

		                        <div class="col-md-4 mb-3">
                                    <label for="puesto">Puesto:</label>
                                    <div v-text="form.puesto" v-if="modal=='show'"></div>
		                            <div v-else>
                                    	<input id="puesto" type="text" class="form-control form-control-sm" name="puesto" placeholder="Puesto" maxlength="25" v-model="form.puesto">
	                                    <div v-if="errors && errors.puesto" class="text-danger">
					                     	{{ errors.puesto[0] }}
					                  	</div>
					                </div>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label for="documento">Identificación:</label>
                                    <div v-text="form.identificacion" v-if="modal=='show'"></div>
		                            <div v-else>
	                                    <input id="documento" type="text" class="form-control form-control-sm" name="documento" placeholder="Documento de Identificación"
	                                    v-model="form.identificacion">
	                                    <div v-if="errors && errors.identificacion" class="text-danger">
					                     	{{ errors.identificacion[0] }}
					                  	</div>
					                </div>
                                </div>

		                        <div class="col-md-3 mb-3">
		                            <label for="nit">NIT:</label>
		                            <div v-text="form.nit" v-if="modal=='show'"></div>
		                            <div v-else>
			                            <input id="nit" type="text" class="form-control form-control-sm" name="nit" placeholder="NIT" maxlength="25" v-model="form.nit">
			                            <div v-if="errors && errors.nit" class="text-danger">
					                     	{{ errors.nit[0] }}
					                  	</div>
					                </div>
		                        </div>

		                        <div class="col-md-4 mb-3">
                                    <label for="fecha_nacimiento">Fecha de Nacimiento:</label>
                                    <div v-text="form.fecha_nacimiento" v-if="modal=='show'"></div>
		                            <div v-else>
	                                    <date-picker 
	                                        id="fecha_nacimiento"
	                                        type="text" 
	                                        class="form-control form-control-sm"
	                                        name="fecha_nacimiento" 
	                                        v-model="form.fecha_nacimiento"
	                                        placeholder="Fecha de Nacimiento"></date-picker>

	                                    <div v-if="errors && errors.fecha_nacimiento" class="text-danger">
					                     	{{ errors.fecha_nacimiento[0] }}
					                  	</div>
					                </div>
                                </div>

		                        <div class="col-md-12 mb-3">
                                    <label for="notas">Notas:</label>
                                    <div v-text="form.notas" v-if="modal=='show'"></div>
		                            <div v-else>
	                                    <textarea id="notas" type="text" class="form-control " name="notas" placeholder="Si necesita, escriba aquí sus notas." maxlength="100" v-model="form.notas"></textarea>
	                                    <div v-if="errors && errors.notas" class="text-danger">
					                     	{{ errors.notas[0] }}
					                  	</div>
					                </div>
                                </div>
							</div>	
						</div>

						<div class="col-md-4">
							<div class="form-row">
		                        <div class="col-md-6 mb-2">
		                            <label for="telefono">Teléfono:</label>
		                            <div v-if="modal=='show'">
		                            	<a :href="'tel:'+form.telefono" v-if="form.telefono">{{form.telefono}}</a>
		                            </div>
		                            <div v-else>
		                            	<input id="telefono" type="text" class="form-control phone" name="telefono" v-model="form.telefono" placeholder="Teléfono">
			                            <div v-if="errors && errors.telefono" class="text-danger">
					                     	{{ errors.telefono[0] }}
					                  	</div>
					                </div>
		                        </div>

		                        <div class="col-md-6 mb-2">
		                            <label for="celular">Celular:</label>
		                            <div v-if="modal=='show'">
		                            	<a :href="'tel:'+form.celular" v-if="form.celular">{{form.celular}}</a>
		                            </div>
		                            <div v-else>
			                            <input id="celular" type="text" class="form-control phone" name="celular" placeholder="Celular" v-model="form.celular">
			                            <div v-if="errors && errors.celular" class="text-danger">
					                     	{{ errors.celular[0] }}
					                  	</div>
					                </div>
		                        </div>

		                        <div class="col-md-12 mb-2">
		                            <label for="email">
		                                Correo electrónico:
		                            </label>
		                            <div v-if="modal=='show'">
		                            	<a :href="'mailto:'+form.email" v-if="form.email">{{form.email}}</a>
		                            </div>
		                            <div v-else>
			                            <input id="email" type="email" class="form-control" name="email" placeholder="Correo electrónico" v-model="form.email">
			                            <div v-if="errors && errors.email" class="text-danger">
					                     	{{ errors.email[0] }}
					                  	</div>
					                </div>
		                        </div>

		                        <div class="col-md-12 mb-2">
		                            <label for="usuario_facebook">Página Web:</label>
		                            <div v-text="form.facebook" v-if="modal=='show'">
		                            	<a :href="form.facebook" v-if="form.facebook">{{form.facebook}}</a>
		                            </div>
		                            <div v-else>
			                            <input id="usuario_facebook" type="text" class="form-control" name="usuario_facebook" placeholder="https://www.site.com/" maxlength="50" v-model="form.facebook">
			                            <div v-if="errors && errors.facebook" class="text-danger">
					                     	{{ errors.facebook[0] }}
					                  	</div>
					                </div>
		                        </div>

		                        <div class="col-md-12 mb-2">
		                            <label for="direccion">Dirección:</label>
		                            <div v-text="form.direccion" v-if="modal=='show'"></div>
		                            <div v-else>
			                            <textarea 
			                            id="direccion" 
			                            type="text" 
			                            class="form-control"
			                            name="direccion" 
			                            placeholder="Dirección"
			                            rows="1"
			                            maxlength="250"
			                            v-model="form.direccion"></textarea>
			                            <div v-if="errors && errors.direccion" class="text-danger">
					                     	{{ errors.direccion[0] }}
					                  	</div>
					                </div>
		                        </div>
		                    </div>
						</div>
					</div>
				</div>

				<div class="modal-footer" v-if="modal!='index'">
					<button type="button" class="btn btn-primary" v-on:click="store" v-if="modal=='create'">
						Crear
					</button>
					<button type="button" class="btn btn-primary" v-on:click="update" v-if="modal=='edit'">
						Actualizar
					</button>
					<button type="button" class="btn btn-secondary" v-on:click="backIndex">
						Cancelar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['cliente', 'disabled'],

		data(){
			return {
				codigo: 0,
				loading: false,
				contactos:[],
				modal: 'index',
				form: {
					codigo: '',
					nombre: '',
					identificacion: '',
					nit: '',
					celular: '',
					direccion: '',
					telefono: '',
					email: '',
					facebook: '',
					fecha_nacimiento: '',
					puesto: '',
					notas: ''
				},
				errors: {},
				compacta: false
			}
		},

		mounted(){
			this.loading = true;
			var vm = this;
			$(this.$el).on('shown.bs.modal', function (event) {
				if (!vm.cliente) {
					var button = $(event.relatedTarget);
					var cliente = button.data('cliente');
					vm.codigo = cliente;
					vm.contactos = []
					vm.getContactos();
					vm.modal = 'index';
				}
			});

			if (this.cliente) {
				this.codigo = this.cliente
				this.contactos = []
				this.getContactos()
			}
		},

		methods: {
			getContactos: function(){
				this.loading = true;
				var url = 'api/clientes/'+this.codigo+'/contactos';

				axios.get(url)
				.then(response => {
					this.contactos = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			backIndex: function(){
				this.modal = 'index'
			},

			create: function(){
				this.modal = 'create'
				$('.tooltip').remove();
				this.cleanFields()
			},

			store: function(){
				this.loading = true
				this.errors = {}

				axios.post('api/clientes/'+this.codigo+'/contactos', {
					nombre: this.form.nombre,
					identificacion: this.form.identificacion,
					nit: this.form.nit,
					celular: this.form.celular,
					direccion: this.form.direccion,
					telefono: this.form.telefono,
					email: this.form.email,
					facebook: this.form.facebook,
					fecha_nacimiento: this.form.fecha_nacimiento,
					puesto: this.form.puesto,
					notas: this.form.notas
				}).then((response) => {
					this.getContactos()
					this.cleanFields()
					this.backIndex()

				}).catch((error) => {
					console.log(error.response);
					this.$toasted.show('Error al agregar Contacto.');
					if (error.response.status === 422) {
						this.errors = error.response.data.errors || {};
					}
				}).then(() => {
					this.loading = false
				})
			},

			edit: function(data){
				this.modal = 'edit'
				
				this.form.codigo = data.CODIGO_CONTACTO;
				this.form.nombre = data.NOMBRE_CONTACTO;
				this.form.identificacion = data.DOCTO_IDENTIFICA;
				this.form.nit = data.NIT;
				this.form.celular = data.CELULAR;
				this.form.direccion = data.DIRECCION;
				this.form.telefono = data.TELEFONO;
				this.form.email = data.EMAIL;
				this.form.facebook = data.USUARIO_FACEBOOK;
				this.form.fecha_nacimiento = data.FECHA_NACIMIENTO;
				this.form.puesto = data.PUESTO;
				this.form.notas = data.NOTAS;
			},

			show: function(data){
				this.modal = 'show'
				
				this.form.codigo = data.CODIGO_CONTACTO;
				this.form.nombre = data.NOMBRE_CONTACTO;
				this.form.identificacion = data.DOCTO_IDENTIFICA;
				this.form.nit = data.NIT;
				this.form.celular = data.CELULAR;
				this.form.direccion = data.DIRECCION;
				this.form.telefono = data.TELEFONO;
				this.form.email = data.EMAIL;
				this.form.facebook = data.USUARIO_FACEBOOK;
				this.form.fecha_nacimiento = data.FECHA_NACIMIENTO;
				this.form.puesto = data.PUESTO;
				this.form.notas = data.NOTAS;
			},

			update: function(){
				this.loading = true
				this.errors = {}

				axios.put('api/clientes/contactos/'+this.form.codigo, {
					nombre: this.form.nombre,
					identificacion: this.form.identificacion,
					nit: this.form.nit,
					celular: this.form.celular,
					direccion: this.form.direccion,
					telefono: this.form.telefono,
					email: this.form.email,
					facebook: this.form.facebook,
					fecha_nacimiento: this.form.fecha_nacimiento,
					puesto: this.form.puesto,
					notas: this.form.notas
				}).then((response) => {
					this.getContactos()
					this.cleanFields()
					this.backIndex()

				}).catch((error) => {
					console.log(error.response);
					this.$toasted.show('Error al actualizar Contacto.');
					if (error.response.status === 422) {
						this.errors = error.response.data.errors || {};
					}
				}).then(() => {
					this.loading = false
				})
			},

			deleteContacto: function(id){
				var url = 'api/clientes/contactos/'+id;
                var modules = this
                $.confirm({
                    title: '¿Estás seguro?',
                    content: '¡Ya no podrás recuperar esta información!',
                    theme: 'supervan', // 'material', 'bootstrap'
                    buttons: {
                        Confirmar: function () {
                            axios.delete(url)
                                .then(response => {
                                	modules.getContactos()
                                	modules.backIndex()

                                    modules.$toasted.show('Eliminado');
                                })
                                .catch(error => {
                                    modules.$toasted.show('Error al eliminar');
                                    console.log(error.response);
                                });
                        },
                        Cancelar: function () {
                        },
                    }
                });
			},

			getIni: function(data){
				return (data.split(' ')[0] || '').toString().charAt(0) + (data.split(' ')[1] || '').toString().charAt(0)
			},

			cleanFields: function(){
				this.form.nombre = '';
				this.form.identificacion = '';
				this.form.nit = '';
				this.form.celular = '';
				this.form.direccion = '';
				this.form.telefono = '';
				this.form.email = '';
				this.form.facebook = '';
				this.form.fecha_nacimiento = '';
				this.form.puesto = '';
				this.form.notas = '';

				this.errors = {}
			}
		},
		computed:{
			disabledDF(){
				return this.disabled
			}
		}
	}
</script>